"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6162],{

/***/ 44254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ DevIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var DevIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "48",
                height: "48",
                rx: "8",
                fill: "#00C875"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.0823 18.6854C20.5179 18.735 18.4564 20.8272 18.4564 23.4035C18.4564 25.9776 20.5142 28.0683 23.0754 28.1215V28.1265H36.7881V28.1226H37.3272V28.1318C37.6002 28.1415 37.8758 28.2482 38.1023 28.4736L40.3903 30.7488C40.8499 31.2059 40.8499 31.9497 40.3903 32.4069L38.1023 34.6821C37.8288 34.9541 37.4838 35.0534 37.1581 35.0175H23.1755C23.1434 35.0175 23.1113 35.0174 23.0793 35.0171L23.0184 35.0174L22.9874 35.0175H22.1198C15.174 34.1911 12.5243 28.596 11.9373 26.2484L11.9138 26.2543C11.6837 25.3422 11.5615 24.3872 11.5615 23.4035C11.5615 17.1265 16.5381 12.0145 22.7619 11.7968C22.8364 11.792 22.9116 11.7896 22.9874 11.7896C23.0195 11.7896 23.0516 11.7897 23.0837 11.7899C23.1142 11.7897 23.1448 11.7896 23.1755 11.7896C23.2504 11.7896 23.3248 11.792 23.3986 11.7967C29.6235 12.0132 34.6014 17.1257 34.6014 23.4035C34.6014 24.3701 34.4833 25.309 34.261 26.2068H26.7847C27.364 25.4231 27.7064 24.4535 27.7064 23.4035C27.7064 20.8277 25.6459 18.7359 23.0823 18.6854ZM10.5349 28.1225H10.1848C8.28079 28.1225 6.7373 29.666 6.7373 31.57C6.7373 33.474 8.28079 35.0175 10.1848 35.0175H16.2326C13.0984 33.1003 11.3599 30.2109 10.5349 28.1225Z",
                fill: "white"
            })
        ]
    });
};


/***/ }),

/***/ 19567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Uu": function() { return /* reexport */ AIIcon; },
  "k1": function() { return /* reexport */ AutomationsIcon; },
  "Mz": function() { return /* reexport */ CRMIcon; },
  "Bz": function() { return /* reexport */ DashboardsIcon; },
  "d$": function() { return /* reexport */ dev_icon/* DevIcon */.d; },
  "zv": function() { return /* reexport */ InfrastructureIcon; },
  "wI": function() { return /* reexport */ IntegrationsIcon; },
  "EW": function() { return /* reexport */ MCPIcon; },
  "AP": function() { return /* reexport */ ServiceIcon; },
  "Wd": function() { return /* reexport */ WmIcon; }
});

// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/dev-icon.js
var dev_icon = __webpack_require__(44254);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/service-icon.js

var ServiceIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "48",
                height: "48",
                rx: "8",
                fill: "#FA4270"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.661 14.8509C13.2565 15.8638 12.084 18.3982 13.1735 20.9858C14.5822 24.3309 20.7807 26.2303 21.0722 26.2728C21.334 26.3133 21.6404 26.1622 21.6404 25.8728C21.6404 25.5834 21.0722 23.1797 21.0722 23.0094C21.0722 22.8392 21.168 22.686 21.3318 22.6179C21.4957 22.5498 28.6837 19.5026 31.0669 18.5003C33.4502 17.4981 34.5801 14.7999 33.5544 12.3655C32.5288 9.93115 29.8157 8.86931 27.4197 9.87795C25.0237 10.8866 18.0655 13.8402 15.661 14.8509Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M32.3122 33.1464C34.7167 32.1335 35.8892 29.5992 34.7997 27.0116C33.391 23.6665 27.1925 21.7795 26.901 21.7369C26.6392 21.6965 26.3328 21.8476 26.3328 22.1369C26.3328 22.4263 26.901 24.8177 26.901 24.9879C26.901 25.1582 26.8052 25.3114 26.6414 25.3795C26.4775 25.4476 19.2895 28.4948 16.9063 29.497C14.523 30.4993 13.3931 33.1975 14.4188 35.6319C15.4444 38.0684 18.1575 39.1281 20.5535 38.1194C22.9516 37.1108 29.9077 34.1572 32.3122 33.1464Z",
                fill: "white"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/crm-icon.js

var CRMIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "48",
                height: "48",
                rx: "8",
                fill: "#00D2D2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24.1191 33.3844C23.4528 32.8913 22.8451 32.3152 22.3121 31.6657C21.0172 30.0879 20.233 28.1619 20.0508 26.1428L30.1529 26.1427C30.6563 26.1424 31.0642 25.7343 31.0642 25.2309C31.0642 23.1705 30.5318 21.1326 29.5028 19.321C28.6751 17.8636 27.5569 16.6074 26.23 15.6224C27.2036 15.3011 28.2443 15.1272 29.3257 15.1272C34.7769 15.1272 39.1959 19.5463 39.1959 24.9975C39.1959 30.4487 34.7769 34.8677 29.3257 34.8677C27.4147 34.8677 25.6305 34.3246 24.1191 33.3844Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.87793 25.2303C8.87793 19.6285 13.4191 15.0874 19.0208 15.0874C20.8485 15.0874 22.5608 15.57 24.0401 16.4142C24.0569 16.4254 24.0741 16.4362 24.0918 16.4463C25.6464 17.3439 26.9437 18.6434 27.8397 20.2208C28.5597 21.4884 28.9928 22.8867 29.122 24.3186H19.0204C18.5168 24.3186 18.1087 24.7268 18.1087 25.2304C18.1087 27.9988 19.0686 30.6817 20.8249 32.8218C21.3919 33.5127 22.0306 34.1332 22.727 34.675C21.5796 35.1256 20.3298 35.3732 19.0208 35.3732C13.4191 35.3732 8.87793 30.8321 8.87793 25.2303Z",
                fill: "white"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/wm-icon.js

var WmIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "48",
                height: "48",
                rx: "8.08909",
                fill: "#6C6CFF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.6134 27.0611C25.382 27.0611 26.8158 25.6274 26.8158 23.8588C26.8158 22.0902 25.382 20.6565 23.6134 20.6565C21.8449 20.6565 20.4111 22.0902 20.4111 23.8588C20.4111 25.6274 21.8449 27.0611 23.6134 27.0611Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.6134 16.078C25.382 16.078 26.8158 14.6442 26.8158 12.8757C26.8158 11.1071 25.382 9.67334 23.6134 9.67334C21.8449 9.67334 20.4111 11.1071 20.4111 12.8757C20.4111 14.6442 21.8449 16.078 23.6134 16.078Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.1652 23.669C14.9338 23.669 16.3675 22.2353 16.3675 20.4667C16.3675 18.6981 14.9338 17.2644 13.1652 17.2644C11.3966 17.2644 9.96289 18.6981 9.96289 20.4667C9.96289 22.2353 11.3966 23.669 13.1652 23.669Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.1545 35.9488C18.9231 35.9488 20.3568 34.5151 20.3568 32.7465C20.3568 30.9779 18.9231 29.5442 17.1545 29.5442C15.3859 29.5442 13.9521 30.9779 13.9521 32.7465C13.9521 34.5151 15.3859 35.9488 17.1545 35.9488Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M30.0656 35.9488C31.8342 35.9488 33.2679 34.5151 33.2679 32.7465C33.2679 30.9779 31.8342 29.5442 30.0656 29.5442C28.297 29.5442 26.8633 30.9779 26.8633 32.7465C26.8633 34.5151 28.297 35.9488 30.0656 35.9488Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.0597 23.669C35.8283 23.669 37.2621 22.2353 37.2621 20.4667C37.2621 18.6981 35.8283 17.2644 34.0597 17.2644C32.2911 17.2644 30.8574 18.6981 30.8574 20.4667C30.8574 22.2353 32.2911 23.669 34.0597 23.669Z",
                fill: "white"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/ai-icon.js

var AIIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "path-1-inside-1_589_3088",
                fill: "white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M15.7196 3.83214L17.0691 4.2596C17.1738 4.29261 17.2451 4.38989 17.2451 4.49985C17.2451 4.60981 17.1738 4.7068 17.0691 4.74011L15.7196 5.16786C15.5737 5.21414 15.4594 5.32852 15.4131 5.47444L14.9854 6.82401C14.9523 6.92866 14.8551 7 14.7451 7C14.6352 7 14.5382 6.92866 14.5049 6.82401L14.0772 5.47444C14.0309 5.32852 13.9165 5.21414 13.7706 5.16786L12.4211 4.74011C12.3165 4.70709 12.2451 4.60952 12.2451 4.49985C12.2451 4.39019 12.3165 4.29291 12.4211 4.2596L13.7706 3.83214C13.9165 3.78586 14.0309 3.67148 14.0772 3.52556L14.5049 2.17599C14.5379 2.07134 14.6352 2 14.7451 2C14.8551 2 14.952 2.07134 14.9854 2.17599L15.4131 3.52556C15.4594 3.67148 15.5737 3.78586 15.7196 3.83214ZM11.4327 10.0881L14.8032 11.1557C15.0645 11.2381 15.2427 11.4811 15.2427 11.7557C15.2427 12.0304 15.0645 12.2726 14.8032 12.3558L11.4327 13.4241C11.0683 13.5397 10.7827 13.8254 10.6671 14.1898L9.5988 17.5605C9.51635 17.8218 9.27339 18 8.99878 18C8.72417 18 8.48196 17.8218 8.39877 17.5605L7.33051 14.1898C7.21492 13.8254 6.92926 13.5397 6.56483 13.4241L3.19441 12.3558C2.93305 12.2733 2.75488 12.0296 2.75488 11.7557C2.75488 11.4818 2.93305 11.2389 3.19441 11.1557L6.56483 10.0881C6.92926 9.97251 7.21492 9.68683 7.33051 9.32238L8.39877 5.95176C8.48122 5.69038 8.72417 5.51221 8.99878 5.51221C9.27339 5.51221 9.51561 5.69038 9.5988 5.95176L10.6671 9.32238C10.7827 9.68683 11.0683 9.97251 11.4327 10.0881Z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.0691 4.2596L16.6917 5.45125L16.693 5.45167L17.0691 4.2596ZM15.7196 3.83214L15.3417 5.02364L15.3422 5.02379L15.7196 3.83214ZM17.0691 4.74011L17.4468 5.93168L17.4483 5.93122L17.0691 4.74011ZM15.7196 5.16786L15.342 3.97628L15.3417 3.97636L15.7196 5.16786ZM15.4131 5.47444L14.2216 5.09655L14.2215 5.09679L15.4131 5.47444ZM14.9854 6.82401L13.7938 6.44635L13.7933 6.44794L14.9854 6.82401ZM14.5049 6.82401L13.3133 7.20166L13.3138 7.20312L14.5049 6.82401ZM14.0772 5.47444L15.2687 5.09679L15.2687 5.09654L14.0772 5.47444ZM13.7706 5.16786L14.1485 3.97636L14.1483 3.97628L13.7706 5.16786ZM12.4211 4.74011L12.7988 3.54853L12.7972 3.54804L12.4211 4.74011ZM12.4211 4.2596L12.0436 3.06795L12.0419 3.06849L12.4211 4.2596ZM13.7706 3.83214L14.148 5.02379L14.1485 5.02364L13.7706 3.83214ZM14.0772 3.52556L15.2687 3.90346L15.2687 3.90321L14.0772 3.52556ZM14.5049 2.17599L15.6965 2.55364L15.697 2.55206L14.5049 2.17599ZM14.9854 2.17599L16.1769 1.79834L16.1765 1.79687L14.9854 2.17599ZM15.4131 3.52556L14.2215 3.90321L14.2216 3.90345L15.4131 3.52556ZM14.8032 11.1557L14.4257 12.3473L14.4271 12.3478L14.8032 11.1557ZM11.4327 10.0881L11.0548 11.2796L11.0553 11.2797L11.4327 10.0881ZM14.8032 12.3558L15.1809 13.5474L15.1823 13.5469L14.8032 12.3558ZM11.4327 13.4241L11.055 12.2325L11.0548 12.2326L11.4327 13.4241ZM10.6671 14.1898L9.47555 13.8119L9.47548 13.8122L10.6671 14.1898ZM9.5988 17.5605L8.40722 17.1828L8.40672 17.1844L9.5988 17.5605ZM8.39877 17.5605L7.20718 17.9381L7.20765 17.9396L8.39877 17.5605ZM7.33051 14.1898L8.52209 13.8122L8.52202 13.8119L7.33051 14.1898ZM6.56483 13.4241L6.94277 12.2326L6.94253 12.2325L6.56483 13.4241ZM3.19441 12.3558L3.5721 11.1642L3.57052 11.1637L3.19441 12.3558ZM3.19441 11.1557L2.81695 9.96403L2.81524 9.96458L3.19441 11.1557ZM6.56483 10.0881L6.94229 11.2797L6.94277 11.2796L6.56483 10.0881ZM7.33051 9.32238L8.52202 9.70027L8.52209 9.70003L7.33051 9.32238ZM8.39877 5.95176L9.59035 6.32941L9.59085 6.32783L8.39877 5.95176ZM9.5988 5.95176L10.7904 5.57411L10.7899 5.57263L9.5988 5.95176ZM10.6671 9.32238L9.47548 9.70003L9.47555 9.70027L10.6671 9.32238ZM17.4466 3.06795L16.0971 2.6405L15.3422 5.02379L16.6917 5.45124L17.4466 3.06795ZM18.4951 4.49985C18.4951 3.84494 18.0706 3.26482 17.4453 3.06752L16.693 5.45167C16.277 5.3204 15.9951 4.93484 15.9951 4.49985H18.4951ZM17.4483 5.93122C18.0687 5.73371 18.4951 5.15708 18.4951 4.49985H15.9951C15.9951 4.06254 16.2788 3.67988 16.69 3.549L17.4483 5.93122ZM16.0973 6.35943L17.4468 5.93168L16.6914 3.54854L15.342 3.97628L16.0973 6.35943ZM16.6046 5.85233C16.528 6.09371 16.339 6.28278 16.0976 6.35935L15.3417 3.97636C14.8085 4.1455 14.3907 4.56333 14.2216 5.09655L16.6046 5.85233ZM16.1769 7.20166L16.6047 5.85209L14.2215 5.09679L13.7938 6.44636L16.1769 7.20166ZM14.7451 8.25C15.4001 8.25 15.9802 7.82535 16.1774 7.20007L13.7933 6.44794C13.9245 6.03197 14.31 5.75 14.7451 5.75V8.25ZM13.3138 7.20312C13.5112 7.82349 14.0878 8.25 14.7451 8.25V5.75C15.1826 5.75 15.5652 6.03383 15.696 6.44489L13.3138 7.20312ZM12.8856 5.85209L13.3133 7.20166L15.6965 6.44636L15.2687 5.09679L12.8856 5.85209ZM13.3927 6.35935C13.1512 6.28278 12.9622 6.09371 12.8856 5.85234L15.2687 5.09654C15.0996 4.56333 14.6818 4.1455 14.1485 3.97636L13.3927 6.35935ZM12.0434 5.93168L13.3929 6.35943L14.1483 3.97628L12.7988 3.54854L12.0434 5.93168ZM10.9951 4.49985C10.9951 5.15361 11.4188 5.73463 12.045 5.93218L12.7972 3.54804C13.2141 3.67956 13.4951 4.06542 13.4951 4.49985H10.9951ZM12.0419 3.06849C11.4207 3.26625 10.9951 3.84377 10.9951 4.49985H13.4951C13.4951 4.93661 13.2122 5.31956 12.8003 5.4507L12.0419 3.06849ZM13.3931 2.6405L12.0436 3.06795L12.7986 5.45124L14.148 5.02379L13.3931 2.6405ZM12.8856 3.14766C12.9622 2.90629 13.1512 2.71722 13.3927 2.64065L14.1485 5.02364C14.6818 4.8545 15.0996 4.43667 15.2687 3.90346L12.8856 3.14766ZM13.3133 1.79834L12.8856 3.14791L15.2687 3.90321L15.6965 2.55364L13.3133 1.79834ZM14.7451 0.75C14.0901 0.75 13.51 1.17467 13.3128 1.79993L15.697 2.55206C15.5657 2.96801 15.1802 3.25 14.7451 3.25V0.75ZM16.1765 1.79687C15.979 1.17649 15.4024 0.75 14.7451 0.75V3.25C14.3077 3.25 13.9251 2.96619 13.7942 2.55512L16.1765 1.79687ZM16.6047 3.14791L16.1769 1.79834L13.7938 2.55364L14.2215 3.90321L16.6047 3.14791ZM16.0976 2.64065C16.339 2.71722 16.528 2.90629 16.6046 3.14767L14.2216 3.90345C14.3907 4.43667 14.8085 4.8545 15.3417 5.02364L16.0976 2.64065ZM15.1806 9.96404L11.8102 8.89645L11.0553 11.2797L14.4257 12.3473L15.1806 9.96404ZM16.4927 11.7557C16.4927 10.9362 15.9613 10.2104 15.1793 9.96361L14.4271 12.3478C14.1677 12.2659 13.9927 12.0261 13.9927 11.7557H16.4927ZM15.1823 13.5469C15.9595 13.2995 16.4927 12.5776 16.4927 11.7557H13.9927C13.9927 11.4831 14.1696 11.2457 14.424 11.1647L15.1823 13.5469ZM11.8104 14.6157L15.1809 13.5474L14.4255 11.1642L11.055 12.2325L11.8104 14.6157ZM11.8586 14.5677C11.8513 14.5906 11.8336 14.6084 11.8107 14.6156L11.0548 12.2326C10.303 12.4711 9.71397 13.0602 9.47555 13.8119L11.8586 14.5677ZM10.7904 17.9381L11.8587 14.5675L9.47548 13.8122L8.40722 17.1828L10.7904 17.9381ZM8.99878 19.25C9.81845 19.25 10.5442 18.7185 10.7909 17.9365L8.40672 17.1844C8.4885 16.9251 8.72834 16.75 8.99878 16.75V19.25ZM7.20765 17.9396C7.45499 18.7167 8.17677 19.25 8.99878 19.25V16.75C9.27157 16.75 9.50893 16.927 9.58989 17.1813L7.20765 17.9396ZM6.13892 14.5675L7.20718 17.9381L9.59035 17.1828L8.52209 13.8122L6.13892 14.5675ZM6.1869 14.6156C6.164 14.6084 6.14624 14.5906 6.139 14.5677L8.52202 13.8119C8.2836 13.0602 7.69452 12.4711 6.94277 12.2326L6.1869 14.6156ZM2.81671 13.5474L6.18714 14.6157L6.94253 12.2325L3.5721 11.1642L2.81671 13.5474ZM1.50488 11.7557C1.50488 12.5737 2.03544 13.3009 2.81829 13.5479L3.57052 11.1637C3.83065 11.2458 4.00488 11.4855 4.00488 11.7557H1.50488ZM2.81524 9.96458C2.03728 10.2122 1.50488 10.9354 1.50488 11.7557H4.00488C4.00488 12.0283 3.82881 12.2655 3.57357 12.3468L2.81524 9.96458ZM6.18738 8.89645L2.81695 9.96404L3.57186 12.3473L6.94229 11.2797L6.18738 8.89645ZM6.139 8.94449C6.14624 8.92165 6.164 8.90386 6.1869 8.8966L6.94277 11.2796C7.69452 11.0411 8.2836 10.452 8.52202 9.70027L6.139 8.94449ZM7.20718 5.57411L6.13892 8.94473L8.52209 9.70003L9.59035 6.32941L7.20718 5.57411ZM8.99878 4.26221C8.17909 4.26221 7.45337 4.79372 7.20668 5.57568L9.59085 6.32783C9.50908 6.58705 9.26925 6.76221 8.99878 6.76221V4.26221ZM10.7899 5.57263C10.5426 4.79553 9.82077 4.26221 8.99878 4.26221V6.76221C8.72602 6.76221 8.48864 6.58523 8.40769 6.33088L10.7899 5.57263ZM11.8587 8.94473L10.7904 5.57411L8.40722 6.32941L9.47548 9.70003L11.8587 8.94473ZM11.8107 8.8966C11.8336 8.90386 11.8513 8.92165 11.8586 8.94449L9.47555 9.70027C9.71397 10.452 10.303 11.0411 11.0548 11.2796L11.8107 8.8966Z",
                fill: color || "#676879",
                mask: "url(#path-1-inside-1_589_3088)"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/dashboards-icon.js

var DashboardsIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "2.32292",
                y: "3.23966",
                width: "15.3542",
                height: "13.5208",
                rx: "1.26042",
                stroke: color || "#676879",
                strokeWidth: "1.14583"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "1.75",
                y1: "6.67708",
                x2: "18.25",
                y2: "6.67708",
                stroke: color || "#676879",
                strokeWidth: "1.14583"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.2399 10C14.2399 9.68359 13.9834 9.42708 13.667 9.42708C13.3506 9.42708 13.0941 9.68359 13.0941 10L14.2399 10ZM13.0941 10L13.0941 16.4167L14.2399 16.4167L14.2399 10L13.0941 10Z",
                fill: color || "#676879"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.5729 10.9167C10.5729 10.6003 10.3164 10.3438 10 10.3438C9.68359 10.3438 9.42708 10.6003 9.42708 10.9167L10.5729 10.9167ZM9.42708 10.9167L9.42708 16.4167L10.5729 16.4167L10.5729 10.9167L9.42708 10.9167Z",
                fill: color || "#676879"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.90592 12.75C6.90592 12.4336 6.64942 12.1771 6.33301 12.1771C6.01659 12.1771 5.76009 12.4336 5.76009 12.75L6.90592 12.75ZM5.76009 12.75L5.76009 16.4167L6.90592 16.4167L6.90592 12.75L5.76009 12.75Z",
                fill: color || "#676879"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/automations-icon.js

var AutomationsIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "4.3329",
                y: "6.55556",
                width: "11.3333",
                height: "9.55556",
                rx: "1.22222",
                stroke: color || "#676879",
                strokeWidth: "1.11111"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.333 9.55542H16.2219C17.2037 9.55542 17.9997 10.3514 17.9997 11.3332V12.2221C17.9997 13.2039 17.2037 13.9999 16.2219 13.9999H15.333",
                stroke: color || "#676879",
                strokeWidth: "1.11111"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.66699 9.55542H3.7781C2.79626 9.55542 2.00032 10.3514 2.00032 11.3332V12.2221C2.00032 13.2039 2.79626 13.9999 3.7781 13.9999H4.66699",
                stroke: color || "#676879",
                strokeWidth: "1.11111"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.2227 10.4443L12.2227 11.7777",
                stroke: color || "#676879",
                strokeWidth: "1.11111",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.77734 10.4443L7.77734 11.7777",
                stroke: color || "#676879",
                strokeWidth: "1.11111",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.5556 3.33325C10.5556 3.02643 10.3068 2.7777 10 2.7777C9.69318 2.7777 9.44444 3.02643 9.44444 3.33325L10.5556 3.33325ZM9.44444 3.33325L9.44444 6.88881L10.5556 6.88881L10.5556 3.33325L9.44444 3.33325Z",
                fill: color || "#676879"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/infrastructure-icon.js

var InfrastructureIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.75 6.25007C3.75 6.91313 4.4085 7.54904 5.58064 8.01789C6.75277 8.48675 8.34253 8.75015 10.0002 8.75015C11.6578 8.75015 13.2476 8.48675 14.4197 8.01789C15.5919 7.54904 16.2504 6.91313 16.2504 6.25007C16.2504 5.58701 15.5919 4.95111 14.4197 4.48225C13.2476 4.0134 11.6578 3.75 10.0002 3.75C8.34253 3.75 6.75277 4.0134 5.58064 4.48225C4.4085 4.95111 3.75 5.58701 3.75 6.25007Z",
                stroke: color || "#676879",
                strokeWidth: "1.25004",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.75 6.25V9.99955C3.75 11.3802 6.54842 12.4996 10.0002 12.4996C13.452 12.4996 16.2504 11.3807 16.2504 9.99955V6.25",
                stroke: color || "#676879",
                strokeWidth: "1.25004",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.75 9.99951V13.7496C3.75 15.1302 6.54842 16.2497 10.0002 16.2497C13.452 16.2497 16.2504 15.1302 16.2504 13.7496V9.99951",
                stroke: color || "#676879",
                strokeWidth: "1.25004",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/integrations-icon.js

var IntegrationsIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_589_3100)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M3.84863 12.293L8.18694 16.5269C8.84001 17.1643 9.88612 17.1516 10.5235 16.4985L13.2608 13.6938L15.9981 10.889C16.6355 10.2359 16.6227 9.18982 15.9697 8.55246L11.6314 4.31848",
                        stroke: color || "#676879",
                        strokeWidth: "1.25"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M2.65137 13.5205L12.8288 3.09233",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M6.5918 2.11961C6.34477 1.87852 5.94908 1.88333 5.70799 2.13036C5.4669 2.37739 5.47171 2.77309 5.71874 3.01418L6.5918 2.11961ZM5.71874 3.01418L9.39928 6.60621L10.2723 5.71163L6.5918 2.11961L5.71874 3.01418Z",
                        fill: color || "#676879"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.9609 14.0007L16.6415 17.5928",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M2.40137 6.41404C2.15434 6.17295 1.75865 6.17777 1.51756 6.4248C1.27647 6.67183 1.28128 7.06753 1.52831 7.30862L2.40137 6.41404ZM1.52831 7.30862L5.20885 10.9006L6.08191 10.0061L2.40137 6.41404L1.52831 7.30862Z",
                        fill: color || "#676879"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_589_3100",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(51351);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/mcp-icon.js


var MCPIcon = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                "clip-path": "url(#clip0_792_2516)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M12.6763 3.01819C11.9491 2.30546 10.7854 2.30546 10.0582 3.01819L3.0618 9.88364C2.81453 10.1164 2.43635 10.1164 2.18907 9.88364C1.95635 9.65091 1.9418 9.27273 2.18907 9.04L9.18544 2.16C10.4073 0.981822 12.3418 0.981822 13.5636 2.16C14.2473 2.82909 14.5818 3.78909 14.4363 4.73455C15.3963 4.60364 16.3709 4.90909 17.0545 5.59273L17.0836 5.63637C18.2618 6.78546 18.2909 8.67637 17.1418 9.86909C17.1273 9.88364 17.0982 9.91273 17.0836 9.92728L10.7563 16.1382C10.6836 16.2109 10.6691 16.3418 10.7563 16.4145L12.0509 17.6945C12.2836 17.9273 12.2982 18.3055 12.0509 18.5382C11.8036 18.7709 11.4254 18.7709 11.1782 18.5382L9.88362 17.2582C9.33089 16.72 9.31635 15.8327 9.85453 15.28C9.85453 15.28 9.86907 15.2655 9.88362 15.2509L16.2109 9.04C16.9236 8.34182 16.9382 7.20728 16.24 6.49455L16.2109 6.46546L16.1818 6.43637C15.4545 5.72364 14.2909 5.72364 13.5636 6.43637L8.3418 11.5564L8.26907 11.6291C8.0218 11.8618 7.64362 11.8618 7.39635 11.6291C7.16362 11.3964 7.14908 11.0182 7.39635 10.7855L12.6909 5.59273C13.4036 4.89455 13.4182 3.76 12.72 3.04728C12.72 3.04728 12.7054 3.03273 12.6909 3.01819H12.6763Z",
                        fill: "#676879"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11.8036 4.73449C12.0363 4.50176 12.0509 4.12358 11.8036 3.89085C11.5563 3.65813 11.1782 3.65813 10.9309 3.89085L5.75271 8.96722C4.57453 10.1163 4.54544 12.0072 5.69453 13.1999C5.70907 13.2145 5.73817 13.2436 5.75271 13.2581C6.97453 14.4363 8.90907 14.4363 10.1309 13.2581L15.3091 8.18176C15.5418 7.94904 15.5563 7.57085 15.3091 7.33813C15.0618 7.1054 14.6836 7.1054 14.4363 7.33813L9.25817 12.4145C8.53089 13.1272 7.36726 13.1272 6.63998 12.4145C5.92726 11.7163 5.91271 10.5818 6.61089 9.86904L6.63998 9.83994L11.8182 4.76358L11.8036 4.73449Z",
                        fill: "#676879"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_792_2516",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "17.4545",
                        fill: "white",
                        transform: "translate(2 1.27271)"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/index.js












/***/ }),

/***/ 95055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* binding */ ProductIcon; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js
var v4 = __webpack_require__(72045);
;// CONCATENATED MODULE: ./segments/desktop/pricing/icons/marketing-icon.js

var MarketingIcon = function(param) {
    var id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "108",
        height: "77",
        viewBox: "0 0 108 77",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M40.8846 31.8694V74.0978C40.8846 75.3963 41.9317 76.449 43.2234 76.449H64.6875C65.9792 76.449 67.0263 75.3963 67.0263 74.0978V35.6944C67.0263 31.6893 70.2579 28.4425 74.2442 28.4425C78.2306 28.4425 81.4622 31.6893 81.4622 35.6944V74.0978C81.4622 75.3963 82.5093 76.449 83.8009 76.449H105.265C106.557 76.449 107.604 75.3963 107.604 74.0978V31.8694C107.604 14.2684 92.6684 0 74.2443 0C55.8203 0 40.8846 14.2684 40.8846 31.8694Z",
                fill: "#CA0C6B"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.307129 31.8694V74.0978C0.307129 75.3963 1.35423 76.449 2.64591 76.449H24.11C25.4017 76.449 26.4488 75.3963 26.4488 74.0978V35.6944C26.4488 31.6893 29.6804 28.4425 33.6667 28.4425C37.6531 28.4425 40.8847 31.6893 40.8847 35.6944V74.0978C40.8847 75.3963 41.9318 76.449 43.2234 76.449H64.6877C65.9794 76.449 67.0265 75.3963 67.0265 74.0978V31.8694C67.0265 14.2684 52.0909 0 33.6668 0C15.2428 0 0.307129 14.2684 0.307129 31.8694Z",
                fill: "url(#paint0_linear_2481_123944-".concat(id, ")")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.307129 51.8892H26.4453V74.1224C26.4453 75.4071 25.4086 76.4487 24.1299 76.4487H2.62255C1.34378 76.4487 0.307129 75.4071 0.307129 74.1224V51.8892Z",
                fill: "#F8C3DD"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M40.8883 51.8892H67.0265V74.1224C67.0265 75.4071 65.9898 76.4487 64.711 76.4487H43.2037C41.925 76.4487 40.8883 75.4071 40.8883 74.1224V51.8892Z",
                fill: "#F8C3DD"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M81.469 51.8892H107.607V74.1224C107.607 75.4071 106.571 76.4487 105.292 76.4487H83.7844C82.5057 76.4487 81.469 75.4071 81.469 74.1224V51.8892Z",
                fill: "#F8C3DD"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint0_linear_2481_123944-".concat(id),
                    x1: "-1.86843",
                    y1: "71.0347",
                    x2: "106.667",
                    y2: "57.1665",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#FF158A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.765625",
                            stopColor: "#FF158A",
                            stopOpacity: "0.5"
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/pricing/icons/software-icon.js

var SoftwareIcon = function(param) {
    var id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "119",
        height: "90",
        viewBox: "0 0 119 90",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "119",
                height: "90",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M46.3084 16.662C46.3084 10.2213 51.5296 5 57.9704 5C79.6724 5 97.2578 22.5854 97.2578 44.2874C97.2578 65.9895 79.6724 83.5748 57.9704 83.5748H14.662C8.22126 83.5748 3 78.3536 3 71.9128C3 65.4721 8.22126 60.2508 14.662 60.2508H57.9704C66.7909 60.2508 73.9338 53.108 73.9338 44.2874C73.9338 35.4669 66.7909 28.324 57.9704 28.324C51.5296 28.324 46.3084 23.1028 46.3084 16.662Z",
                fill: "url(#paint0_linear_2426_1297)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M19.3438 44.2874C19.3438 22.5854 36.9291 5 58.6312 5C65.0719 5 70.2932 10.2213 70.2932 16.662C70.2932 23.1028 65.0719 28.324 58.6312 28.324C49.8106 28.324 42.6678 35.4669 42.6678 44.2874C42.6678 53.108 49.8106 60.2508 58.6312 60.2508H106.503V83.5748H58.6312C36.9291 83.5748 19.3438 65.9895 19.3438 44.2874Z",
                fill: "#00CA72"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M116.834 69.1374C118.389 70.6837 118.389 73.1999 116.834 74.7462L109.094 82.4428C106.6 84.9237 102.35 83.1567 102.35 79.6384L102.35 64.2452C102.35 60.7269 106.6 58.9599 109.094 61.4408L116.834 69.1374Z",
                fill: "#00CA72"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint0_linear_2426_1297",
                    x1: "74.4638",
                    y1: "31.3159",
                    x2: "67.4632",
                    y2: "63.8687",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            "stop-color": "#00CA72"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.905957",
                            "stop-color": "#00CA72",
                            "stop-opacity": "0.6"
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/dev-icon.js
var dev_icon = __webpack_require__(44254);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/index.js + 9 modules
var icons = __webpack_require__(19567);
;// CONCATENATED MODULE: ./segments/desktop/pricing/icons/project-management-icon.js

var ProjectManagementIcon = function(param) {
    var id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "108",
        height: "105",
        viewBox: "0 0 108 105",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M27.066 18.5174C27.066 16.0799 28.3867 13.8276 30.5307 12.6089L50.4255 1.29956C52.5695 0.0808159 55.2109 0.0808198 57.3549 1.29956L77.2498 12.6089C79.3937 13.8276 80.7145 16.0799 80.7145 18.5174L80.7156 45.0751L53.8913 60.3235C44.95 55.2407 36.0086 50.158 27.0671 45.0752C27.0671 36.2226 27.066 27.3702 27.066 18.5174Z",
                fill: "url(#paint0_linear_2481_124011-".concat(id, ")")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M27.0666 45.076C19.2958 49.5186 11.4929 53.9141 3.7059 58.3407C1.56195 59.5595 0.241213 61.8118 0.24121 64.2493L0.241212 86.8679C0.241212 89.3053 1.56194 91.5577 3.7059 92.7764L23.6007 104.086C25.7447 105.304 28.3862 105.304 30.5301 104.086L53.8908 90.821L53.8908 60.3243C44.9473 55.2404 36.007 50.1582 27.0666 45.076Z",
                fill: "url(#paint1_linear_2481_124011-".concat(id, ")")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M104.073 58.3406C106.217 59.5594 107.538 61.8117 107.538 64.2492L107.538 86.8678C107.538 89.3053 106.217 91.5576 104.073 92.7763L84.1785 104.086C82.0346 105.304 79.3931 105.304 77.2491 104.086L53.8891 90.8212L53.8891 60.3245C62.8305 55.2418 71.7719 50.1589 80.7133 45.0762C88.4865 49.5201 96.289 53.9156 104.073 58.3406Z",
                fill: "url(#paint2_linear_2481_124011-".concat(id, ")")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                styles: "mix-blend-mode:multiply",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M27.066 47.0451C27.066 45.8264 27.7264 44.7002 28.7984 44.0908L52.1579 30.812C53.2299 30.2026 54.5506 30.2026 55.6226 30.812L78.9822 44.0908C80.0541 44.7002 80.7145 45.8263 80.7145 47.0451L80.7145 73.6027C80.7145 74.8215 80.0541 75.9476 78.9822 76.557L55.6226 89.8358C54.5507 90.4452 53.2299 90.4452 52.1579 89.8358L28.7984 76.557C27.7264 75.9476 27.0661 74.8215 27.0661 73.6027L27.066 47.0451Z",
                    fill: "url(#paint3_linear_2481_124011-".concat(id, ")")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_2481_124011-".concat(id),
                        x1: "27.0659",
                        y1: "14.6157",
                        x2: "80.2724",
                        y2: "45.841",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FB9000"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFCB00"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_2481_124011-".concat(id),
                        x1: "53.8897",
                        y1: "60.2978",
                        x2: "0.683283",
                        y2: "91.523",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FB9000"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFCB00"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint2_linear_2481_124011-".concat(id),
                        x1: "53.8897",
                        y1: "60.2976",
                        x2: "107.096",
                        y2: "91.5224",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FB9000"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFCB00"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint3_linear_2481_124011-".concat(id),
                        x1: "53.8903",
                        y1: "30.355",
                        x2: "53.8903",
                        y2: "90.2929",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FDAB3D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFCB00",
                                stopOpacity: "0.51"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/pricing/icons/product-icon.js







var productNameToIconMap = {
    core: icons/* WmIcon */.Wd,
    projectManagement: ProjectManagementIcon,
    software: SoftwareIcon,
    marketing: MarketingIcon,
    crm: icons/* CRMIcon */.Mz,
    service: icons/* ServiceIcon */.AP,
    serviceWhite: icons/* ServiceIcon */.AP,
    coreWhite: icons/* WmIcon */.Wd,
    softwareWhite: dev_icon/* DevIcon */.d,
    crmWhite: icons/* CRMIcon */.Mz
};
var ProductIcon = function(param) {
    var product = param.product;
    var IconComponent = productNameToIconMap[product];
    return IconComponent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconComponent, {
        id: (0,v4/* default */.Z)()
    }) : null;
};


/***/ }),

/***/ 86162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ multi_products_pricing_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./segments/desktop/pricing/product-pricing-config.js
var product_pricing_config = __webpack_require__(69535);
// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-component.js + 2 modules
var signup_form_component = __webpack_require__(24494);
// EXTERNAL MODULE: ./segments/desktop/pricing/layouts/prices-and-features-cards-pricing/index.js + 4 modules
var prices_and_features_cards_pricing = __webpack_require__(16834);
// EXTERNAL MODULE: ./segments/desktop/pricing/layouts/features-table-pricing/index.js + 2 modules
var features_table_pricing = __webpack_require__(77552);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/desktop/pricing/icons/product-icon.js + 3 modules
var product_icon = __webpack_require__(95055);
// EXTERNAL MODULE: ./components/enhancements/tooltip/tooltip-constants.js
var tooltip_constants = __webpack_require__(24984);
// EXTERNAL MODULE: ./components/enhancements/tooltip/tooltip-component.js + 1 modules
var tooltip_component = __webpack_require__(31590);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/multi-products-pricing/components/product-switcher.scss.js



var StyledProductSwitcher = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e12xydaw0"
})("z-index:", z_index/* TOP_LAYER */.nA, ";margin-top:0px;margin-bottom:42px;display:flex;align-items:center;justify-content:center;width:100%;position:relative;.product-item{width:98px;height:150px;display:flex;flex-direction:column;margin-right:22px;margin-left:14px;.product-button{display:flex;flex:1;flex-direction:column;align-items:center;background-color:transparent;.icon-container{display:flex;align-items:flex-end;flex:1;.product-icon{display:flex;border-radius:12px;width:72px;height:72px;justify-content:center;align-items:center;transition:transform 0.1s;background-color:var(--switcher-color);svg{width:74px;height:74px;}&.is-selected-product{width:94px;height:94px;svg{width:84px;height:84px;}}}}.icon-container:hover{transition-timing-function:ease-in;transition:transform 0.6s cubic-bezier(0.16,1,0.3,1);transform:scale3d(1.05,1.05,1);&.is-selected-product{transition:none;transform:none;}}.product-label{padding-top:16px;color:", colors/* default.asphalt */.Z.asphalt, ";height:30%;font-size:16px;&.is-selected-product{font-weight:600;color:", colors/* default.mud */.Z.mud, ";}}svg{width:42px;height:42px;}}.tooltip{border-radius:4px;opacity:0;display:none;z-index:", z_index/* TOP_LAYER */.nA, ";top:100%;left:100%;transform:translate(-50%);margin-top:8px;.floating-tooltip{white-space:normal;padding:8px;width:272px;line-height:20px;}}.tooltip:after{visibility:visible;opacity:1;z-index:", z_index/* TOP_LAYER */.nA, ";bottom:100%;rotate:180deg;left:38%;transform:translate(-100%);}}.product-item:hover{.tooltip{display:block;opacity:1;}}button{border:none;}");

;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/multi-products-pricing/components/product-switcher.js










var ProductSwitcher = function(param) {
    var onProductChange = param.onProductChange, selectedProduct = param.selectedProduct, config = param.config, translate = param.translate;
    var ref = (0,react.useState)(false), hideTooltip = ref[0], setHideTooltip = ref[1];
    var products = (0,react.useMemo)(function() {
        var ans = [];
        Object.entries(config).map(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            if (value.showInSwitcher) {
                ans.push({
                    id: key,
                    label: value.switcherLabel,
                    color: value.switcherIconColor,
                    iconName: "".concat(key, "White"),
                    order: value.orderInSwitcher,
                    tooltipLabelKey: value.switcherTooltipLabelKey
                });
            }
        });
        ans.sort(function(a, b) {
            return a.order - b.order;
        });
        return ans;
    }, [
        config
    ]);
    var onMouseEnter = function(productIdHovered) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_PRODUCT_SWITCHER_TOOLTIP_SHOWN, {
            info1: selectedProduct,
            info2: productIdHovered,
            productKind: selectedProduct
        });
    };
    var onMouseLeave = function(productIdHovered) {
        setHideTooltip(false);
        tackOnTooltipHidden(productIdHovered);
    };
    var tackOnTooltipHidden = function(productIdHovered) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_PRODUCT_SWITCHER_TOOLTIP_HIDDEN, {
            info1: selectedProduct,
            info2: productIdHovered,
            productKind: selectedProduct
        });
    };
    var onProductSwitch = function(productId) {
        if (productId !== selectedProduct) {
            setHideTooltip(true);
            tackOnTooltipHidden(productId);
        }
        onProductChange(productId);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProductSwitcher, {
        className: "switcher-container",
        children: products.map(function(product) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("product-item", {
                    "is-selected-product": selectedProduct === product.id
                }),
                onMouseEnter: function() {
                    return onMouseEnter(product.id);
                },
                onMouseLeave: function() {
                    return onMouseLeave(product.id);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    style: {
                        "--switcher-color": product.color
                    },
                    type: "button",
                    className: "product-button",
                    onClick: function() {
                        onProductSwitch(product.id);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("icon-container", {
                                "is-selected-product": selectedProduct === product.id
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("product-icon", {
                                    "is-selected-product": selectedProduct === product.id
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(product_icon/* ProductIcon */.w, {
                                    product: product.iconName
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()("product-label", {
                                "is-selected-product": selectedProduct === product.id
                            }),
                            children: [
                                product.label,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tooltip",
                                    children: !hideTooltip && /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_component/* default */.Z, {
                                        theme: tooltip_constants.DARK_THEME,
                                        className: "floating-tooltip",
                                        children: translate(product.tooltipLabelKey)
                                    })
                                })
                            ]
                        })
                    ]
                }, product.id)
            });
        })
    });
};

;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/multi-products-pricing/multi-products-pricing-component.scss.js

var StyledMultiProductsPricingComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1vk7m3w0"
})("margin:auto;.product-switcher{margin-bottom:390px;}.signup-form{.ladda-button-component{.signup-button,.cta-button{background-color:var(--primary-color);letter-spacing:0.4px;max-width:none;width:100%;border:none;padding:16px 24px;font-size:16px;font-weight:400;}}}.signup-form:hover{.signup-button:hover,.cta-button:hover{background-color:var(--secondary-color);}}");

// EXTERNAL MODULE: ./services/pricing-service.js + 2 modules
var pricing_service = __webpack_require__(15650);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/multi-products-pricing/multi-products-pricing-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}












var MultiProductsPricingComponent = function(props) {
    var abTests = (0,react.useContext)(ab_tests_context/* AbTestsContext */.s).abTests;
    var pricesAndFeaturesCardsPricing = props.pricesAndFeaturesCardsPricing, translate = props.translate;
    var _productName = pricesAndFeaturesCardsPricing.productName, productName = _productName === void 0 ? undefined : _productName, _isHomepagePricing = pricesAndFeaturesCardsPricing.isHomepagePricing, isHomepagePricing = _isHomepagePricing === void 0 ? false : _isHomepagePricing, _isApplyMaxDiffFeatures = pricesAndFeaturesCardsPricing.isApplyMaxDiffFeatures, isApplyMaxDiffFeatures = _isApplyMaxDiffFeatures === void 0 ? false : _isApplyMaxDiffFeatures, _defaultSeatsIndex = pricesAndFeaturesCardsPricing.defaultSeatsIndex, defaultSeatsIndex = _defaultSeatsIndex === void 0 ? 0 : _defaultSeatsIndex;
    var ref = (0,react.useState)(productName), selectedProductName = ref[0], setSelectedProductName = ref[1];
    var selectedProductColors = (0,react.useMemo)(function() {
        var _selectedProductName = product_pricing_config/* default */.Z[selectedProductName], primaryColor = _selectedProductName.primaryColor, secondaryColor = _selectedProductName.secondaryColor;
        return {
            primaryColor: primaryColor,
            secondaryColor: secondaryColor
        };
    }, [
        selectedProductName
    ]);
    var onProductChange = (0,react.useCallback)(function(newProductName) {
        if (newProductName === selectedProductName) return;
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_PRODUCT_SWITCHER_CLICKED, {
            info1: selectedProductName,
            info2: newProductName,
            productKind: selectedProductName
        });
        setSelectedProductName(newProductName);
    }, [
        selectedProductName
    ]);
    var getSelectedProductId = function() {
        var productId = product_pricing_config/* default */.Z[selectedProductName].productId;
        return productId;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMultiProductsPricingComponent, {
        className: "multi-products-pricing-component",
        style: {
            "--primary-color": selectedProductColors.primaryColor,
            "--secondary-color": selectedProductColors.secondaryColor
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSwitcher, {
                onProductChange: onProductChange,
                selectedProduct: selectedProductName,
                config: product_pricing_config/* default */.Z,
                translate: translate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, {
                className: "signup-form",
                ctaText: translate("signup.cta"),
                buttonColor: selectedProductColors.primaryColor,
                buttonSize: "xs",
                useCtaText: true,
                withButtonArrow: true,
                signupProductId: getSelectedProductId(),
                extraData: {
                    productKind: selectedProductName,
                    cta_name: "main_cta"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(prices_and_features_cards_pricing/* default.PricesAndFeaturesCardsPricingComponent */.Z.PricesAndFeaturesCardsPricingComponent, _object_spread_props(_object_spread({}, props), {
                productName: selectedProductName,
                isHomepagePricing: isHomepagePricing,
                defaultSeatsIndex: defaultSeatsIndex,
                isApplyMaxDiffFeatures: isApplyMaxDiffFeatures,
                isNewPricing: (0,pricing_service/* shouldSeeNewPricing */.RW)(selectedProductName, abTests)
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(features_table_pricing/* default.FeaturesTablePricingComponent */.Z.FeaturesTablePricingComponent, _object_spread_props(_object_spread({}, props), {
                productName: selectedProductName,
                isHomepagePricing: isHomepagePricing,
                defaultSeatsIndex: defaultSeatsIndex,
                isApplyMaxDiffFeatures: isApplyMaxDiffFeatures,
                isNewPricing: (0,pricing_service/* shouldSeeNewPricing */.RW)(selectedProductName, abTests)
            }))
        ]
    });
};
/* harmony default export */ var multi_products_pricing_component = (MultiProductsPricingComponent);


/***/ }),

/***/ 51351:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _throw; }
/* harmony export */ });
function _throw(e) {
    throw e;
}

/***/ })

}]);